"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreservationProgram = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const PreludeCard_1 = require("../prelude/PreludeCard");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Units_1 = require("../../Units");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Card_1 = require("../Card");
class PreservationProgram extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.PRESERVATION_PROGRAM,
            tr: { tr: 5 },
            metadata: {
                cardNumber: 'P57',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.tr(5).digit;
                    b.preludeBox('effect', (ce) => {
                        ce.effect('Skip the first TR you gain in each generation\'s action phase.', (eb) => {
                            eb.startEffect.text('SKIP FIRST').tr(1);
                        });
                    });
                }),
                description: 'Raise your TR 5 steps.',
            },
        });
    }
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (!super.canPlay(player))
            return false;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        player.preservationProgramActive = true;
        player.increaseTerraformRatingSteps(5);
        return undefined;
    }
    getActionDetails(_player, card) {
        return new RedsPolicy_1.ActionDetails({ card: card, TRIncrease: 5 });
    }
}
exports.PreservationProgram = PreservationProgram;
//# sourceMappingURL=PreservationProgram.js.map